var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folders"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.25002 3.66699H11L12.8334 5.50033H17.4167C18.4292 5.50033 19.25 6.32114 19.25 7.33366V13.7503C19.25 14.7628 18.4292 15.5837 17.4167 15.5837H8.25002C7.2375 15.5837 6.41669 14.7628 6.41669 13.7503V5.50033C6.41669 4.4878 7.2375 3.66699 8.25002 3.66699",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15.5833 15.583V17.4163C15.5833 18.4289 14.7625 19.2497 13.75 19.2497H4.58333C3.57081 19.2497 2.75 18.4289 2.75 17.4163V9.16634C2.75 8.15382 3.57081 7.33301 4.58333 7.33301H6.41667",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.7d2243d02b2382861edf15e6a72d4990.svg";
export { ForwardRef as ReactComponent };